// extracted by mini-css-extract-plugin
module.exports = {"AvatarPic":"Avatar_AvatarPic__J1c6e","AvatarPicDisabled":"Avatar_AvatarPicDisabled__Mzyl_","AvatarPicPlaceholder":"Avatar_AvatarPicPlaceholder__qXQRY"};